import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
// import { getInvoiceOrigin } from '../../../core';
import { getDiagnoseDetail } from '../../../core';
import { DecisionTree } from '../examination-start/decision-tree';
import { CustomLoader } from '../../../components/basic/loader';
import { ScoreAlg } from '../examination-start/score-alg';

// todo back button functionality

export const ExaminationDetail = () => {
  const navigate = useNavigate();
  const { id, productId } = useParams();
  const [type, setType] = useState('');
  const [loading, setLoading] = useState(true);
  const [dataa, setDataa] = useState<{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    edges: any[];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    vertices: any[];
  }>({
    edges: [],
    vertices: []
  });
  const [dataaS, setDataaS] = useState<{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    questions: any[];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    options: any[];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    results: any[];
  }>({
    questions: [],
    options: [],
    results: []
  });

  useEffect(() => {
    if (id) {
      (async () => {
        try {
          setLoading(true);
          const { data, status } = await getDiagnoseDetail(parseInt(id ?? '-1'));
          if (status === 200) {
            console.log(data);
            if (data.path_of_diagnosis_vertices.search('question_title') > 0) {
              setType('score');
            } else {
              setType('des_t');
            }

            setDataa(data);
            setDataaS(data);
          }
          setLoading(false);
        } catch (e) {
          console.log(e);
          setLoading(false);
        }
      })();
    } else {
      navigate('/examinations');
    }
  }, [id]);

  if (loading) {
    return <CustomLoader />;
  }
  return (
    <>
      {type === 'des_t' ? (
        <>
          <DecisionTree
            data={dataa}
            productId={parseInt(productId ?? '-1')}
            invoiceId={-1}
            refNumber={'-1'}
            viewMode={true}
          />
        </>
      ) : (
        <>
          <ScoreAlg
            data={dataaS}
            productId={parseInt(productId ?? '-1')}
            invoiceId={-1}
            refNumber={'-1'}
            viewMode={true}
          />
        </>
      )}
    </>
  );
};
